import NoWastedLabels from './icons/no-wasted-labels.svg';
import QualityRatesWorldwide from './icons/quality-rates-worldwide.svg';
import NoMinimumVolue from './icons/no-minimum-volume.svg';
import OneClickSetup from './icons/one-click-setup.svg';

interface ISBRBenefit {
    icon: React.ReactNode;
    title: string;
    description: string;
};


const sbrBenefits: ISBRBenefit[] = [
    {
        icon: NoWastedLabels,
        title: 'No Wasted Labels',
        description: 'Get credited for unused return labels',
    },
    {
        icon: QualityRatesWorldwide,
        title: 'Quality Rates Worldwide',
        description: 'Pre-negotiated rates from a wide network of carriers around the world.',
    },
    {
        icon: NoMinimumVolue, // TODO: fix icon
        title: 'No Minimum Volume',
        description: 'Use Ship by ReturnGO with any number of returns.',
    },
    {
        icon: OneClickSetup,
        title: 'One-Click Setup',
        description: 'No integration or third-party necessary.',
    }
];

export default sbrBenefits;